import { WireTypes } from "@flakiness/server/common/wireTypes.js";
import { html, TemplateResult } from "lit";
import { markdown } from "../markdown.js";
import { accessToken } from "./welcome_new_project.js";

export type OtherCITabsOptions = {
  idPrefix: string,
  project: WireTypes.Project,
  testCommand: string,
  junitPath: string,
  category?: string,
};

export function otherCITabs(opts: OtherCITabsOptions): { navs: TemplateResult, panels: TemplateResult } {
  const projectSlug = `${opts.project.org.orgSlug}/${opts.project.projectSlug}`;
  const categoryFlag = opts.category ? ` --category ${opts.category}` : '';
  const unixId = `${opts.idPrefix}-other-ci-unix`;
  const winId = `${opts.idPrefix}-other-ci-windows`;

  const unixPanel = markdown`
    Set the \`FLAKINESS_ACCESS_TOKEN\` environment variable to ${accessToken(opts.project)}, install the standalone \`flakiness-junit-xml\` binary (no Node.js required), run your tests, then convert and upload:

    ${markdown.bash(`
      curl -fsSL https://github.com/flakiness/junit-xml/releases/latest/download/install.sh | sh
      ${opts.testCommand}
      FLAKINESS_ACCESS_TOKEN=<token> flakiness-junit-xml ${opts.junitPath}${categoryFlag} --flakiness-project ${projectSlug}
    `)}
  `;

  const windowsPanel = markdown`
    Set the \`FLAKINESS_ACCESS_TOKEN\` environment variable to ${accessToken(opts.project)}, install the standalone \`flakiness-junit-xml\` binary (no Node.js required), run your tests, then convert and upload:

    ${markdown.powershell(`
      irm https://github.com/flakiness/junit-xml/releases/latest/download/install.ps1 | iex
      ${opts.testCommand}
      $env:FLAKINESS_ACCESS_TOKEN = "<token>"
      flakiness-junit-xml ${opts.junitPath}${categoryFlag} --flakiness-project ${projectSlug}
    `)}
  `;

  return {
    navs: html`
      <sl-tab slot="nav" panel="${unixId}">Other CI: Mac / Linux</sl-tab>
      <sl-tab slot="nav" panel="${winId}">Other CI: Windows</sl-tab>
    `,
    panels: html`
      <sl-tab-panel name="${unixId}">${unixPanel}</sl-tab-panel>
      <sl-tab-panel name="${winId}">${windowsPanel}</sl-tab-panel>
    `,
  };
}
